///import { gsap } from 'gsap'
//import { ScrollTrigger } from 'gsap/src/ScrollTrigger'

import konamiCode from './utilities/konami-code.js'

import '../../components/atoms/**/*.js'
import '../../components/molecules/**/*.js'
import '../../components/organisms/**/*.js'
import '../../components/structures/**/*.js'

console.log('\n %cMade with %c♥%c by Fabrique \n', 'font: 16px serif;', 'font: 13px serif; color: #f00;', 'font: 16px serif;')

// GSAP
//window.GSAP = window.gsap ?? gsap
//window.ScrollTrigger = window.ScrollTrigger ?? ScrollTrigger
//window.GSAP.registerPlugin(window.ScrollTrigger)
//window.GSAP.ticker.sleep() // Prevent GSAP ticker from leaking memory when not in use -EKL
// Check for re-layout and recalculate, otherwise ScrollTrigger can lose track -EKL
//const observer = new ResizeObserver(() => window.ScrollTrigger.refresh())
//observer.observe(document.body)

// There are 4 load events:
// - 'init-immediate': (compiles when the script is loaded; blocks rendering)
// - 'init-load': (on DOMContentLoaded event; does not block rendering)
// - 'init-after-load': (on Load event, slightly after DOMContentLoaded)
// - 'init-delayed-load': (after Load event, with a slight delay, for iframes and such)
// Usually, the 'init-load' event will suffice.
window.dispatchEvent(new CustomEvent('init-immediate'))
window.addEventListener('DOMContentLoaded', () => window.dispatchEvent(new CustomEvent('init-load')))
window.addEventListener('load', () => window.dispatchEvent(new CustomEvent('init-after-load')))
window.addEventListener('load', () => window.setTimeout(() => window.dispatchEvent(new CustomEvent('init-delayed-load')), 1000))

// Focus stuff
document.addEventListener('keydown', () => document.documentElement.classList.add('key-pressed'))
document.addEventListener('mousedown', () => document.documentElement.classList.remove('key-pressed'))
document.addEventListener('touchstart', () => document.documentElement.classList.remove('key-pressed'))

konamiCode()

window.addEventListener('konami', () => {
  document.documentElement.classList.add('konami')

  window.setTimeout(() => document.documentElement.classList.remove('konami'), 2500)
})

// eslint-disable-next-line no-undef
if (environment === 'debug') {
  const runAxe = async () => {
    const axe = (await import('axe-core')).default
    const results = await axe.run().catch(e => console.error(e))

    if (results.incomplete?.length) {
      results.incomplete.forEach(result => console.warn('Axe', result))
    }

    if (results.violations?.length) {
      results.violations.forEach(result => console.error('Axe', result))
    }
  }

  window.addEventListener('init-delayed-load', () => window.setTimeout(() => runAxe(), 1000))
}
